import React from 'react';
import './NoMatch.css'

const NoMatch = () => {
    return (
        <div className='noMatch'>
            <h1>404 Error!</h1>
            <h1>This is not a webpage you are looking for.</h1>
        </div>
    );
};

export default NoMatch;